import { Button, HStack, Text, VStack } from '@chakra-ui/react';

interface ProjectsHeaderProps {
  type: string;
  onTypeChange: (type: string) => void;
}
export const ProjectsHeader = ({ type, onTypeChange }: ProjectsHeaderProps) => {
  const getButtonVariant = (type: string, selectedType: string) => {
    return type === selectedType ? 'solid' : 'outline';
  };
  return (
    <VStack spacing={8} w={'100%'} h="100%" display={'flex'} justifyContent="center" alignItems="center">
      <VStack spacing={0}>
        <Text fontSize={{ base: '20px', sm: '24px', md: '28px', lg: '32px', xl: '36px' }} color="black" fontWeight="bold">
          My Projects
        </Text>
        <Text fontSize={{ base: '10px', sm: '12px', md: '12px', lg: '14px', xl: '16px' }} color="gray.500">
          Feel free to reach out if you have any questions!
        </Text>
      </VStack>
      <HStack>
        <Button colorScheme="blue" variant={getButtonVariant(type, 'All')} onClick={() => onTypeChange('All')}>
          All
        </Button>
        <Button colorScheme="blue" variant={getButtonVariant(type, 'Mobile Apps')} onClick={() => onTypeChange('Mobile Apps')}>
          Mobile Apps
        </Button>
        <Button colorScheme="blue" variant={getButtonVariant(type, 'Websites')} onClick={() => onTypeChange('Websites')}>
          Websites
        </Button>
      </HStack>
    </VStack>
  );
};
